import moment from 'moment'

import config from '../../../config'

export const contentTimezone = config.contentTimezone

export function formatSentDate (val) {
  if (!val) return ''
  const format = 'MMM D, YYYY, h:mm a zz'
  const sentDate = moment(val).tz(contentTimezone)
  return sentDate.format(format)
}

export function formatGroup (val) {
  return val || 'All Groups'
}

export function formatMembers (val, resource) {
  const {
    include_checked_in_users: checkedIn,
    include_not_checked_in_users: notCheckedIn
  } = resource

  if (checkedIn && notCheckedIn) {
    return 'All'
  } else if (checkedIn) {
    return 'Checked In'
  } else if (notCheckedIn) {
    return 'Haven\'t Checked In'
  } else {
    return 'None'
  }
}

export function formatStatus (val) {
  switch (val) {
    case 'PENDING':
      return 'Pending'
    case 'IN_PROGRESS':
      return 'In Progress'
    case 'FAILED':
      return 'Failed'
    case 'COMPLETE':
      return 'Sent'
    default:
      return 'Unknown'
  }
}
